var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSdImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#er6dccmekxa)",
    d: "M388.2 145.6 327.4 116s-.1 0-.2-.1c-.1 0-.1-.1-.2-.1-.2-.1-.4-.2-.6-.2h-.1c-.3-.1-.5-.1-.8-.2h-.9c-.3 0-.5 0-.8.1h-.1c-.2 0-.5.1-.7.2h-.1c-.3.1-.5.2-.7.3l-66 31-68.8-63.4s-.1 0-.1-.1c-.2-.2-.4-.3-.6-.5s-.4-.3-.7-.4c-.1 0-.1-.1-.1-.1-.2-.1-.5-.2-.7-.3s-.5-.1-.8-.2H44c-2.6 0-4.8 1.6-5.7 4s-.1 5.1 1.9 6.7l137 109.8v179.3c0 2.8 2 5.3 4.7 5.9.4.1.9.1 1.3.1 2.3 0 4.5-1.3 5.4-3.5l41.7-91.1c.7-1.6.7-3.4 0-5l-4-8.6 82-75.6s0-.1.1-.1l.2-.2s0-.1.1-.1c0-.1.1-.1.2-.2s.1-.2.2-.3c0-.1.1-.1.1-.2.1-.1.1-.2.2-.3 0-.1.1-.1.1-.2.1-.1.1-.3.2-.4v-.2c.1-.2.1-.3.2-.5v-.1c0-.1 0-.2.1-.3v-.1l11.7-43.8h63.9c2.8 0 5.2-1.9 5.9-4.6s-.8-5.6-3.3-6.8m-72.5-13.4-14.5 56.1-35.4-32.6zm-126.4 94.9 22.6 49.5-22.6 20.9zm0-125.4 61.8 57 37.9 34.9h-99.8v-91.9zm-12-7.7v93.1L61.1 94zm41.1 196.7-29.1 63.6v-40.5l27.9-25.7zm-25.8-85.1H289l-67.8 62.5zM324.8 145l3.9-15 30.8 15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "er6dccmekxa",
    x1: 70.7729,
    x2: 295.802,
    y1: 52.7376,
    y2: 277.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a866ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4adede"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdImg);
export default __webpack_public_path__ + "static/media/sd-img.39bcb8ce0e98253eb959e6df53480fb6.svg";
export { ForwardRef as ReactComponent };